import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	date: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.date',
		defaultMessage: 'Date',
		description: 'label for date field',
	},
	placeholder: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.placeholder',
		defaultMessage: 'DD/MM/YY',
		description: 'place holder message for date picker',
	},
	emptyDate: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.empty-date',
		defaultMessage: 'Please provide a date',
		description: 'error message displayed when date is empty',
	},
	invalidDate: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.invalid-date',
		defaultMessage: 'Invalid date format',
		description: 'error message displayed when date is invalid',
	},
});
